import { Navigate, useSearchParams } from 'react-router-dom';

/**
 * /admin/users is retired.
 *
 * User management now lives inside each customer's detail page
 * (/admin/customers/:customerId/users). This route is kept only so old links
 * resolve: a `?customer=<uuid>` param deep-links straight to that customer's
 * Users tab; otherwise we fall back to the customers index.
 */
export default function AdminUsers() {
  const [params] = useSearchParams();
  const customer = params.get('customer');
  const to = customer
    ? `/admin/customers/${customer}/users`
    : '/admin/customers';
  return <Navigate to={to} replace />;
}
